import React from "react";
import { useSelector } from "react-redux";
import TemplateSetupPreview from "./TemplateSetupPreview";
import TemplateCreationPreview from "./TemplateCreationPreview";
import { Paper, Typography } from "@mui/material";

const TemplatePreview = () => {
  // Access the current active step from the template slice
  const { activeStep } = useSelector((state) => state.template);

  // Step 2 ("Submit for review") shows the preview inline in its own main
  // content column instead, right under Name/Language, for every category
  // — see TemplateSubmission.jsx / AuthenticationSubmission.jsx — so this
  // side panel renders nothing there to avoid showing the preview twice.
  if (activeStep === 2) {
    return null;
  }

  const renderPreview = () => {
    switch (activeStep) {
      case 0:
        return <TemplateSetupPreview />;
      case 1:
        return (
          <>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Preview
            </Typography>
            <TemplateCreationPreview />
          </>
        );
      default:
        // If you have more steps, handle them here or return null
        return null;
    }
  };

  return (
    <>
      <Paper
        elevation={1}
        sx={{
          padding: 3,
          borderRadius: "10px",
          backgroundColor: (theme) => theme.palette.background.paper,
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
              : "0px 4px 10px rgba(0, 0, 0, 0.1)",
          width: 250,
        }}
      >
        {renderPreview()}
      </Paper>
    </>
  );
};

export default TemplatePreview;
